// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
// Replace with your actual Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyCnSMKuUV8BnM60eKwjHWsuBKl8-n47t_o",
    authDomain: "bencobos.firebaseapp.com",
    projectId: "bencobos",
    storageBucket: "bencobos.firebasestorage.app",
    messagingSenderId: "70000436297",
    appId: "1:70000436297:web:01ac563eea4e5cf9460b98",
    measurementId: "G-W04LS40BWB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;